(function ($) {

    $('#desktop_menu').on('animationend', function () {

        $(this).addClass('is-active');
        $('.site-nav__close').addClass('is-active');

    });

    $('#desktop_menu').on('toggle', function (event) {

        var panel = $('#main_menu');

        if (event.originalEvent.newState == 'closed') {

            $('#desktop_menu, .desktop-nav__menu__panel, .desktop-nav__menu__drawer, .site-nav__close').removeClass('is-active');
            $('.desktop-nav').css('padding-right', '170px');

        } else {


        }

    });

    $('.site-nav__menu__item').on('click', function () {


        var elem = $(this),
            panel = '#' + elem.data('panel');

        if (elem.hasClass('is-active')) {

            window.location.href = elem.data('url');

        } else {

            $('.site-nav__menu__item').removeClass('is-active');
            $('.desktop-nav__inner .site-nav__menu__item[data-panel="' + elem.data('panel') + '"]').addClass('is-active');

            $('.desktop-nav__menu__panel').removeClass('is-active');
            $(panel).addClass('is-active');

        }

    });

    $('.desktop-nav__menu__item').on('click', function () {

        var elem = $(this),
            drawer = '#' + elem.data('drawer');
        //     drawerOffset = $(drawer).offset().left,
        //     rightEdge = drawerOffset + $(drawer).outerWidth(),
        //     drawerWidth = rightEdge += (rightEdge / 100 * 100);
        //
        // console.log('Drawer Width: ' + drawerWidth + 'px');
        //
        // if (!$(drawer).hasClass('is-active')) {
        //
        //     $('.desktop-nav').animate({paddingRight: drawerWidth + 'px'}, 300);
        //
        //     $('.desktop-nav__menu__drawer').removeClass('is-active');
        //     $(drawer).addClass('is-active');
        //
        // }

        if (!$(drawer).hasClass('is-active')) {

            $('.desktop-nav__menu__drawer').removeClass('is-active').children().removeClass('is-active');

            var elem = $(this),
                drawer = $('#' + elem.data('drawer'));

            $(drawer).addClass('is-active');

            var drawerWidth = drawer.outerWidth() + 60;

            $('.desktop-nav').animate({paddingRight: drawerWidth + 'px'}, 300, function () {
                    $(drawer).children().addClass('is-active');
                }
            );

        }

    });

    function alignDesktopNav() {

        // Get the left offset of the .wrapper
        var wrapperOffset = $('.site-head__main__inner').offset().left;

        // Align the left edge of .desktop-nav with .wrapper
        $('.desktop-nav').css({

            left: wrapperOffset + 'px'

        });
    }


    // Initial alignment
    alignDesktopNav();

    // Re-align on window resize
    $(window).resize(function () {

        alignDesktopNav();

    });


}(jQuery));